import { render, staticRenderFns } from "./MultiselectPagination.vue?vue&type=template&id=469fe205&"
import script from "./MultiselectPagination.vue?vue&type=script&lang=js&"
export * from "./MultiselectPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports